import { useContext, useEffect, useState } from "react";
import { LicenseeInfo } from "../../../generated/data-contracts";
import { LicenseesUrls, LicenseesUtils, api } from "../../../utils";
import { AvisLoader } from "../../shared/components";
import { LandingPage } from "../../shared/components/landingPage/LandingPage";
import { LandingPageAction } from "../../shared/components/landingPage/LandingPageAction";
import { AvisContext } from "../../shared/context/AvisContext";

export function LandingPageLicensees() {
  const { res } = useContext(AvisContext);
  const [loadingLicenseeInfo, setLoadingLicenseeInfo] = useState<boolean>(true);
  const [licenseeInfo, setLicenseeInfo] = useState<LicenseeInfo | undefined>();

  useEffect(() => {
    setLoadingLicenseeInfo(true);

    api
      .licenseesGetLicenseeInfo()
      .then((res) => {
        setLicenseeInfo(res.data);
      })
      .finally(() => setLoadingLicenseeInfo(false));
  }, []);

  if (loadingLicenseeInfo) return <AvisLoader />;

  return (
    <LandingPage
      title={res("licensees_LandingPage_WelcomeText")}
      textKey="portal_LIC_Start"
    >
      <LandingPageAction
        buttonText={res("licensees_Licenses_PageTitle_actual")}
        navigateTo={LicenseesUtils.getUrlWithParams(
          LicenseesUrls.licenseeLicenses,
        )}
        textKey={
          licenseeInfo?.hasActiveLicenses
            ? "portal_LIC_Start_ActiveLic_1"
            : "portal_LIC_Start_ActiveLic_2"
        }
      />
      <LandingPageAction
        buttonText={res("licensees_LicenseReports_PageTitle_actual")}
        navigateTo={LicenseesUtils.getUrlWithParams(
          LicenseesUrls.licenseeReports,
        )}
        textKey={
          licenseeInfo?.hasActiveLicenseReports
            ? "portal_LIC_Start_OverdueReports_1"
            : "portal_LIC_Start_OverdueReports_2"
        }
      />
      <LandingPageAction
        buttonText={res("licensees_Invoices_PageTitle_actual")}
        navigateTo={LicenseesUtils.getUrlWithParams(
          LicenseesUrls.licenseeInvoices,
        )}
        textKey={
          licenseeInfo?.hasActiveInvoices
            ? "portal_LIC_Start_UnpaidInvoices_1"
            : "portal_LIC_Start_UnpaidInvoices_2"
        }
      />
    </LandingPage>
  );
}
